var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.adjustmentCount > 0
        ? _c(
            "div",
            { staticClass: "f-s-16 p-l-15 col-md-offset-3 col-sm-offset-2" },
            [
              _vm._v(
                "\n    Adjust " + _vm._s(_vm.adjustmentCount) + " call(s)\n  "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isOnConfirmation
        ? _c("ValidationObserver", {
            ref: "formValidation",
            attrs: { slim: "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function({ invalid }) {
                    return [
                      _c(
                        "form",
                        {
                          ref: "container",
                          staticClass: "form-horizontal p-t-10 p-b-30",
                          attrs: { role: "form", novalidate: "" },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "col-sm-2 col-md-3 control-label"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(_vm.conversionAdjustmentLabel)
                                    ) + "\n          "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip.right",
                                          value: _vm.$t(
                                            _vm.conversionAdjustmentTooltip
                                          ),
                                          expression:
                                            "$t(conversionAdjustmentTooltip)",
                                          modifiers: { right: true }
                                        }
                                      ]
                                    },
                                    [
                                      _vm._v("\n              "),
                                      _c("i", {
                                        staticClass: "fa fa-question-circle"
                                      })
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("ValidationProvider", {
                                attrs: {
                                  rules: _vm.conversionAmountValidationRule,
                                  slim: ""
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function({ classes, failedRules }) {
                                        return [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "col-xs-3 col-sm-2 col-md-1"
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "currency" },
                                                [_vm._v("$")]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.number",
                                                    value:
                                                      _vm.data
                                                        .conversionAdjustmentAmount,
                                                    expression:
                                                      "data.conversionAdjustmentAmount",
                                                    modifiers: { number: true }
                                                  },
                                                  {
                                                    name: "focus",
                                                    rawName: "v-focus"
                                                  }
                                                ],
                                                staticClass: "form-control",
                                                class: classes,
                                                attrs: {
                                                  type: "number",
                                                  min: 0
                                                },
                                                domProps: {
                                                  value:
                                                    _vm.data
                                                      .conversionAdjustmentAmount
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      _vm.data,
                                                      "conversionAdjustmentAmount",
                                                      _vm._n(
                                                        $event.target.value
                                                      )
                                                    )
                                                  },
                                                  blur: function($event) {
                                                    return _vm.$forceUpdate()
                                                  }
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          failedRules.min_value
                                            ? _c("div", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value:
                                                      "CONVERSION_ADJUSTMENT_MIN_INVALID",
                                                    expression:
                                                      "'CONVERSION_ADJUSTMENT_MIN_INVALID'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-md-9 col-xs-12 col-lg-9 col-lg-offset-3 col-md-offset-3 col-sm-offset-3 text-danger hidden-xs"
                                              })
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isAdmin
                            ? _c(
                                "div",
                                { staticClass: "form-group" },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "col-sm-2 col-md-3 control-label"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "PAYOUT_ADJUSTMENT_AMOUNT_LABEL"
                                          )
                                        ) + "\n          "
                                      ),
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip.right",
                                              value: _vm.$t(
                                                "PAYOUT_ADJUSTMENT_AMOUNT_TT"
                                              ),
                                              expression:
                                                "$t('PAYOUT_ADJUSTMENT_AMOUNT_TT')",
                                              modifiers: { right: true }
                                            }
                                          ]
                                        },
                                        [
                                          _vm._v("\n              "),
                                          _c("i", {
                                            staticClass: "fa fa-question-circle"
                                          })
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("ValidationProvider", {
                                    attrs: {
                                      rules: _vm.payoutAmountValidationRule,
                                      slim: ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function({
                                            classes,
                                            failedRules
                                          }) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-xs-3 col-sm-2 col-md-1"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "currency" },
                                                    [_vm._v("$")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName:
                                                          "v-model.number",
                                                        value:
                                                          _vm.data
                                                            .payoutAdjustmentAmount,
                                                        expression:
                                                          "data.payoutAdjustmentAmount",
                                                        modifiers: {
                                                          number: true
                                                        }
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    class: classes,
                                                    attrs: {
                                                      type: "number",
                                                      min: -_vm.callPayoutAmount
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.data
                                                          .payoutAdjustmentAmount
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.data,
                                                          "payoutAdjustmentAmount",
                                                          _vm._n(
                                                            $event.target.value
                                                          )
                                                        )
                                                      },
                                                      blur: function($event) {
                                                        return _vm.$forceUpdate()
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              failedRules.min_value
                                                ? _c("div", {
                                                    directives: [
                                                      {
                                                        name: "t",
                                                        rawName: "v-t",
                                                        value:
                                                          "PAYOUT_ADJUSTMENT_MIN_INVALID",
                                                        expression:
                                                          "'PAYOUT_ADJUSTMENT_MIN_INVALID'"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "col-md-9 col-xs-12 col-lg-9 col-lg-offset-3 col-md-offset-3 col-sm-offset-3 text-danger hidden-xs"
                                                  })
                                                : _vm._e()
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isAdmin
                            ? _c("div", { staticClass: "form-group" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "col-sm-2 col-md-3 control-label"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CONVERSION_ADJUSTMENT_REASON_LABEL"
                                        )
                                      ) + "\n          "
                                    ),
                                    _c(
                                      "a",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip.right",
                                            value: _vm.$t(
                                              "CONVERSION_ADJUSTMENT_REASON_TT"
                                            ),
                                            expression:
                                              "$t('CONVERSION_ADJUSTMENT_REASON_TT')",
                                            modifiers: { right: true }
                                          }
                                        ]
                                      },
                                      [
                                        _vm._v("\n              "),
                                        _c("i", {
                                          staticClass: "fa fa-question-circle"
                                        })
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "col-xs-12 col-sm-5 col-md-3"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.data.reason,
                                          expression: "data.reason"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      domProps: { value: _vm.data.reason },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.data,
                                            "reason",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-sm-offset-2 col-md-offset-3 col-md-7"
                              },
                              [
                                _c(
                                  "PrimaryButton",
                                  {
                                    attrs: {
                                      size: "sm",
                                      disabled: invalid || _vm.emptyValues,
                                      "show-loader-on-form": _vm.showLoader
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.isOnConfirmation = true
                                      }
                                    }
                                  },
                                  [
                                    _vm.isAdmin
                                      ? _c("span", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value:
                                                "PAYOUT_ADJUSTMENT_SEND_BTN",
                                              expression:
                                                "'PAYOUT_ADJUSTMENT_SEND_BTN'"
                                            }
                                          ]
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.isAdmin
                                      ? _c("span", {
                                          directives: [
                                            {
                                              name: "t",
                                              rawName: "v-t",
                                              value:
                                                "CONVERSION_ADJUSTMENT_SEND_BTN",
                                              expression:
                                                "'CONVERSION_ADJUSTMENT_SEND_BTN'"
                                            }
                                          ]
                                        })
                                      : _vm._e()
                                  ]
                                ),
                                _vm._v(" "),
                                _c("button", {
                                  directives: [
                                    {
                                      name: "t",
                                      rawName: "v-t",
                                      value: "CANCEL",
                                      expression: "'CANCEL'"
                                    }
                                  ],
                                  staticClass: "btn btn-sm btn-danger m-l-15",
                                  attrs: { type: "button" },
                                  on: { click: _vm.closeForm }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              3337957317
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isOnConfirmation
        ? _c(
            "div",
            { ref: "container", staticClass: "ag-grid__overlay-form-box" },
            [
              _c(
                "CallLogActionConfirmation",
                {
                  attrs: {
                    "return-to-review-label": _vm.$t("REVIEW_CHANGES"),
                    "pending-bulk-call-adjustment-by-logs":
                      _vm.pendingBulkCallAdjustmentByLogs
                  },
                  on: {
                    confirmAction: _vm.callPaymentAdjustmentSubmit,
                    cancelForm: _vm.closeForm,
                    returnToReviewDetails: function($event) {
                      _vm.isOnConfirmation = false
                    }
                  }
                },
                [
                  !_vm.selectedCallsCount
                    ? _c(
                        "p",
                        {
                          staticClass:
                            "p-l-15 col-sm-offset-3 col-md-5 col-sm-6 float-none"
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(
                                _vm.isBulkAdjustment
                                  ? _vm.$t(
                                      "BULK_CONVERSION_ADJUSTMENT_MESSAGE",
                                      { adjustmentCount: _vm.adjustmentCount }
                                    )
                                  : _vm.$t(
                                      "SINGLE_CONVERSION_ADJUSTMENT_MESSAGE"
                                    )
                              ) +
                              "\n      "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { staticClass: "col-sm-3 control-label" }, [
                      _vm._v(_vm._s(_vm.$t(_vm.conversionAdjustmentLabel)))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-4 col-md-3" }, [
                      _c(
                        "label",
                        { staticClass: "form-control-static" },
                        [
                          _vm.conversionAdjustmentAmountHasValue
                            ? [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("currency")(
                                        _vm.data.conversionAdjustmentAmount
                                      )
                                    ) +
                                    "\n            "
                                )
                              ]
                            : _c("span", { staticClass: "text-muted" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("ORIGINAL_VALUE_UNCHANGED")) +
                                    "\n            "
                                )
                              ])
                        ],
                        2
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.isAdmin
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("label", { staticClass: "col-sm-3 control-label" }, [
                          _vm._v(
                            _vm._s(_vm.$t("PAYOUT_ADJUSTMENT_AMOUNT_LABEL"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-sm-4 col-md-3" }, [
                          _c(
                            "label",
                            { staticClass: "form-control-static" },
                            [
                              _vm.payoutAdjustmentAmountHasValue
                                ? [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm._f("currency")(
                                            _vm.data.payoutAdjustmentAmount
                                          )
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                : _c("span", { staticClass: "text-muted" }, [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("ORIGINAL_VALUE_UNCHANGED")
                                        ) +
                                        "\n            "
                                    )
                                  ])
                            ],
                            2
                          )
                        ])
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }